/**
 * https://developer.paypal.com/api/rest/reference/currency-codes/
 *
 * decimal - This currency does not support decimals. If you pass a decimal amount, an error occurs.
 *
 * restrictedToCountry - This currency is supported as a payment currency and a currency balance for in-country PayPal
 *      accounts only. If the receiver of funds is not from Brazil, then PayPal converts funds into the primary holding
 *      currency of the account with the applicable currency conversion rate. The currency conversion rate includes
 *      PayPal's applicable spread or fee.
 *
 * restrictedToInCountryAccounts - This currency is supported as a payment currency and a currency balance for
 *      in-country PayPal accounts only.
 */
export const PayPalCurrencies = {
    AUD: { code: "AUD", name: "Australian dollar", symbol: "AUD $", format: "$%" },
    BRL: { code: "BRL", name: "Brazilian real", symbol: "BRL $", restrictedToCountry: true, format: "R$ %" },
    CAD: { code: "CAD", name: "Canadian dollar", symbol: "CAD $", format: "$%" },
    CNY: { code: "CNY", name: "Chinese Renmenbi", symbol: "¥", restrictedToInCountryAccounts: true, format: "¥%" },
    CZK: { code: "CZK", name: "Czech koruna", symbol: "CZK č", format: "% Kč" },
    DKK: { code: "DKK", name: "Danish krone", symbol: "DKK r", format: "% kr" },
    EUR: { code: "EUR", name: "Euro", symbol: "€", format: "% €" },
    HKD: { code: "HKD", name: "Hong Kong dollar", symbol: "HKD $", format: "HK$%" },
    HUF: { code: "HUF", name: "Hungarian forint", symbol: "HUF t", decimal: false, format: "% Ft" },
    ILS: { code: "ILS", name: "Israeli new shekel", symbol: "₪", format: "% ₪" },
    JPY: { code: "JPY", name: "Japanese yen", symbol: "¥", decimal: false, format: "¥%" },
    MYR: { code: "MYR", name: "Malaysian ringgit", symbol: "MYR M", format: "RM%" },
    MXN: { code: "MXN", name: "Mexican peso", symbol: "MXN $", format: "$%" },
    TWD: { code: "TWD", name: "New Taiwan dollar", symbol: "TWD $", decimal: false, format: "NT$%" },
    NZD: { code: "NZD", name: "New Zealand dollar", symbol: "NZD $", format: "$%" },
    NOK: { code: "NOK", name: "Norwegian krone", symbol: "NOK r", format: "% kr" },
    PHP: { code: "PHP", name: "Philippine peso", symbol: "₱", format: "₱%" },
    PLN: { code: "PLN", name: "Polish złoty", symbol: "PLN ł", format: "% zł" },
    GBP: { code: "GBP", name: "Pound sterling", symbol: "£", format: "£%" },
    // RUB: { code: "RUB", name: "Russian ruble", symbol: "₽", format: "% ₽" },
    SGD: { code: "SGD", name: "Singapore dollar", symbol: "SGD $", format: "S$%" },
    SEK: { code: "SEK", name: "Swedish krona", symbol: "SEK r", format: "% kr" },
    CHF: { code: "CHF", name: "Swiss franc", symbol: "CHF F", format: "% CHF" },
    THB: { code: "THB", name: "Thai baht", symbol: "฿", format: "฿%" },
    USD: { code: "USD", name: "United States dollar", symbol: "$", format: "$%" },
};

export const PayPalCurrenciesValues = Object.values(PayPalCurrencies);
